export type ChristmasReview = {
  id: string;
  author: string; // Customer name exactly as shown in the original review
  text: string; // Review text exactly as written — must be about Christmas lights / holiday decorating
  rating?: number; // 1–5, only if shown in the original review
  date?: string; // e.g. "December 2025", only if shown in the original review
  source: 'google' | 'other'; // Use 'google' ONLY if the review was posted on Google
  url?: string; // Link to the original review, if available
};

// Paste the verified Google Business Profile reviews URL here (leave empty until verified).
export const googleProfileUrl = '';

// Add up to 30 genuine reviews about Chacon’s Lawncare CHRISTMAS LIGHT installation or holiday decorating.
// Do not include general lawn care reviews. Copy reviews exactly — do not edit or invent.
// Example format:
// {
//   id: 'review-1',
//   author: 'Name as shown on Google',
//   text: 'Review text copied exactly.',
//   rating: 5,
//   date: 'December 2025',
//   source: 'google',
//   url: 'https://...',
// },
export const christmasReviews: ChristmasReview[] = [];

export const MAX_REVIEWS = 30;
